
import React from 'react'
import PageWrapper from '../../Components/Other/PageWrapper'
import { useEffect } from 'react';
import DetailHeader from '../../Components/DiseaseDetail/DetailHeader'
function Sunburn(props) {
    useEffect(() => {

    })
    return (
        <PageWrapper className={"dis-05-autism-page"}>
            <>
                {/*?php include 'header.php'; ?*/}
                <div className="pageWrapper">
                    <DetailHeader diseaseName={"Sunburn"}></DetailHeader>
                    <div className="MainContent">
                        <div className="container">
                            <div className="page-rte">
                                <p>
                                    <a href='https://www.medicinenet.com/sunburn_symptoms_and_signs/symptoms.htm' className='links'>Sunburn</a> is an inflammation of the skin caused by overexposure to UV <a href='https://www.medicinenet.com/radiation_therapy/article.htm' className='links'>radiation</a> from the sun.
                                </p>

                                <div className="row">
                                    <div className="col-12 textCenter">
                                        <img src={require("../../img/Disease/sunburn/1.png")} alt="sunburn" />
                                    </div>
                                </div>
                                <br></br>
                                <p><b>Symptoms</b></p>
                                <p>Immediate symptoms of a sunburn are:</p>
                             
                                <p>hot, red, tender skin</p>
                                <p><a className='links' href='https://www.medicinenet.com/pain_management/article.htm'>pain</a> when the skin is touched or rubbed</p>
                                <p><a className='links' href='https://www.medicinenet.com/dehydration/article.htm'>Dehydration</a></p>
                                <p>Several days after sun exposure the skin may, swell, <a className='links' href='https://www.medicinenet.com/blisters/symptoms.htm'>blister</a>, peel, and <a href='https://www.medicinenet.com/itch/article.htm' className='links'>itch</a>.</p>
                                <p>Most sunburns are mild and can be treated at home with natural home remedies that provide <a className='links' href='https://www.medicinenet.com/pain_quiz/quiz.htm'>pain</a> relief, treat and sooth <a className='links' href='https://www.medicinenet.com/blisters/symptoms.htm'>blister</a>, peeling, and <a className='links' href='https://www.medicinenet.com/eczema_facts/article.htm'>skin inflammation</a>. </p>
                                <a className="links" href="https://en.wikipedia.org/wiki/Sunburn">
                                    For More Details
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/*?php include 'footer.php'; ?*/}
            </>

        </PageWrapper>
    );
}

export default Sunburn;